import { LockLarge } from "assets/svg";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const StyledIcon = styled(LockLarge)``;
